import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const SearchIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.56 13.44L12.89 10.76C13.59 9.67 14 8.38 14 7C14 3.13 10.87 0 7 0C3.13 0 0 3.13 0 7C0 10.87 3.13 14 7 14C8.39 14 9.68 13.58 10.76 12.89L13.44 15.56C13.71 15.83 14.09 16 14.5 16C15.33 16 16 15.33 16 14.5C16 14.09 15.83 13.71 15.56 13.44ZM6.99997 12C4.23996 12 1.99997 9.76 1.99997 7C1.99997 4.24 4.23996 2 6.99997 2C9.75997 2 12 4.24 12 7C12 9.76 9.75997 12 6.99997 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default SearchIcon;
